export const SYSTEM_MESSAGES = {
    IMPORT_SUCCESS: 'PropertyWare data was successfully imported to the app',
    IMPORT_FAILED: 'Unexpected error occurred during importing properties. Please, try again later',
};

export const SNACK_TIMEOUT = 5000;
export const DEBOUNCE = 400;